import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty, css } from 'lit-element';
import { getData } from './utils';
let data = [];
for (let i = 0; i < 50; i++) {
    data.push(...getData().map(e => {
        e.id = `${e.id}${i === 0 ? '' : `-${i}`}`;
        return e;
    }));
}
let DemoPerformance = class DemoPerformance extends LitElement {
    constructor() {
        super(...arguments);
        this.showParseAndRender = false;
        this.hide = false;
    }
    static get styles() {
        return [css `
      .small-cell {
        width: 150px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `];
    }
    render() {
        return html `
      <cds-button action="outline" size="sm" @click=${() => { this.showParseAndRender = !this.showParseAndRender; this.hide = !this.showParseAndRender; }}>Render Large Grid</cds-button>
      <cds-button action="outline" size="sm" ?hidden=${!this.showParseAndRender} @click=${() => this.hide = !this.hide}>hidden</cds-button>
      <br />
      ${this.showParseAndRender ? html `
        <cds-grid ?hidden=${this.hide} style="--body-height: 300px; --row-height: 36px">
          <cds-grid-column>Stock</cds-grid-column>
          <cds-grid-column>Average</cds-grid-column>
          <cds-grid-column>Current</cds-grid-column>
          <cds-grid-column>About</cds-grid-column>
          ${data.map(entry => html `
            <cds-grid-row>
              <cds-grid-cell>${entry.id}</cds-grid-cell>
              <cds-grid-cell>$${entry.average}</cds-grid-cell>
              <cds-grid-cell>$${entry.value}</cds-grid-cell>
              <cds-grid-cell><div class="small-cell">${entry.about}</div></cds-grid-cell>
            </cds-grid-row>
          `)}
          <cds-grid-footer>
            <p style="margin: 0; line-height: 0">${data.length} Rows ${data.length * 4} Cells</p>
          </cds-grid-footer>
        </cds-grid>` : ''}
    `;
    }
};
__decorate([
    internalProperty()
], DemoPerformance.prototype, "showParseAndRender", void 0);
__decorate([
    internalProperty()
], DemoPerformance.prototype, "hide", void 0);
DemoPerformance = __decorate([
    customElement('demo-performance')
], DemoPerformance);
export { DemoPerformance };
//# sourceMappingURL=demo.performance.js.map